import { useQuery } from 'react-query';
import { client } from 'utils/api-client';

export default function useFetchEmployeeDocuments(queryKey: [string, string]) {
  return useQuery(queryKey, (_, id) =>
    client(`employees/${id}/documents/`).then((res) => res)
  );
}
